import { Button, Dialog, IconButton, Stack, Text, styled } from 'shell/components';

const IntroductionDialog = ({ open, onClose }) => {
    return (
        <CustomDialog aria-labelledby={'dialog-title'} open={open} onClose={onClose}>
            <Stack spacing={8}>
                <Stack spacing={4}>
                    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                        <Text id={'dialog-title'} component={'h1'} variant={'h6'} weight={'semibold'}>
                            Getting Started with AI Feedback
                        </Text>
                        <IconButton
                            aria-label={'close'}
                            kind={'exit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={onClose}
                        />
                    </Stack>
                    <Stack spacing={2}>
                        <Text variant={'p1'} weight={'semibold'}>
                            How it Works
                        </Text>
                        <Text>
                            The AI utilizes the assignment rubric and examples of your instructor’s feedback to deliver
                            personalized feedback tailored this deliverable.
                        </Text>
                    </Stack>
                    <Stack spacing={2}>
                        <Text variant={'p1'} weight={'semibold'}>
                            Implementing Feedback
                        </Text>
                        <Text>
                            The AI’s feedback is intended to supplement, not replace, human evaluation. If there’s
                            something you’re unsure of, please double check with your instructor.
                        </Text>
                    </Stack>
                </Stack>
                <Button sx={{ alignSelf: 'center' }} onClick={onClose}>
                    I Understand
                </Button>
            </Stack>
        </CustomDialog>
    );
};

const CustomDialog = styled(Dialog)(() => {
    return {
        '& .MuiPaper-root': {
            width: '480px',
        },
    };
});

export default IntroductionDialog;
